"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/internal_service.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalOrderServiceGetOrderByIdResponse = exports.InternalOrderServiceGetOrderByIdRequest = exports.InternalOrderServiceGetBankAccountByBrandIdResponse = exports.InternalOrderServiceGetBankAccountByBrandIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const internal_common_pb_1 = require("./internal_common_pb");
/**
 * @generated from message spwn.order.v1.InternalOrderServiceGetBankAccountByBrandIdRequest
 */
class InternalOrderServiceGetBankAccountByBrandIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderServiceGetBankAccountByBrandIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderServiceGetBankAccountByBrandIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderServiceGetBankAccountByBrandIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderServiceGetBankAccountByBrandIdRequest, a, b);
    }
}
exports.InternalOrderServiceGetBankAccountByBrandIdRequest = InternalOrderServiceGetBankAccountByBrandIdRequest;
InternalOrderServiceGetBankAccountByBrandIdRequest.runtime = protobuf_1.proto3;
InternalOrderServiceGetBankAccountByBrandIdRequest.typeName = "spwn.order.v1.InternalOrderServiceGetBankAccountByBrandIdRequest";
InternalOrderServiceGetBankAccountByBrandIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderServiceGetBankAccountByBrandIdResponse
 */
class InternalOrderServiceGetBankAccountByBrandIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderServiceGetBankAccountByBrandIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderServiceGetBankAccountByBrandIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderServiceGetBankAccountByBrandIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderServiceGetBankAccountByBrandIdResponse, a, b);
    }
}
exports.InternalOrderServiceGetBankAccountByBrandIdResponse = InternalOrderServiceGetBankAccountByBrandIdResponse;
InternalOrderServiceGetBankAccountByBrandIdResponse.runtime = protobuf_1.proto3;
InternalOrderServiceGetBankAccountByBrandIdResponse.typeName = "spwn.order.v1.InternalOrderServiceGetBankAccountByBrandIdResponse";
InternalOrderServiceGetBankAccountByBrandIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bank", kind: "message", T: internal_common_pb_1.InternalBankAccount },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderServiceGetOrderByIdRequest
 */
class InternalOrderServiceGetOrderByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderServiceGetOrderByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderServiceGetOrderByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderServiceGetOrderByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderServiceGetOrderByIdRequest, a, b);
    }
}
exports.InternalOrderServiceGetOrderByIdRequest = InternalOrderServiceGetOrderByIdRequest;
InternalOrderServiceGetOrderByIdRequest.runtime = protobuf_1.proto3;
InternalOrderServiceGetOrderByIdRequest.typeName = "spwn.order.v1.InternalOrderServiceGetOrderByIdRequest";
InternalOrderServiceGetOrderByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.order.v1.InternalOrderServiceGetOrderByIdResponse
 */
class InternalOrderServiceGetOrderByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalOrderServiceGetOrderByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalOrderServiceGetOrderByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalOrderServiceGetOrderByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalOrderServiceGetOrderByIdResponse, a, b);
    }
}
exports.InternalOrderServiceGetOrderByIdResponse = InternalOrderServiceGetOrderByIdResponse;
InternalOrderServiceGetOrderByIdResponse.runtime = protobuf_1.proto3;
InternalOrderServiceGetOrderByIdResponse.typeName = "spwn.order.v1.InternalOrderServiceGetOrderByIdResponse";
InternalOrderServiceGetOrderByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order", kind: "message", T: internal_common_pb_1.InternalOrder },
]);
//# sourceMappingURL=internal_service_pb.js.map